export class MarcaBlanca {
    nanotecnias: String[] = ["gpstrack", "track3", "qagpstrack", "localhost", "track3s3"];
  // Obtener el subdominio de la aplicación
  SubDomain(): string {
    //let url: string = "http://qa-betterfield.gpschile.com/";
    //let url: string = "https://track3.gpschile.com/tracker";
    let url: string = window.location.href;
    // Utilizamos una expresión regular para extraer el subdominio de la URL
    var subdominio = url.match(/^(?:https?:\/\/)?([^/.]+)/i);

    // Si se encontró un subdominio, lo retornamos
    if (subdominio && subdominio.length > 1) {
      return subdominio[1].split(':')[0].toString().toLowerCase();
    } else {
      return ''; // No se encontró un subdominio
    }
  }
  getSubDomain(): string{
    return (this.nanotecnias.includes(this.SubDomain())) ? 'gpschile': this.SubDomain().replaceAll("qa-", "");
  }
}
